export const removeEmptyFields = (params: any): any => {
  for (let key in params) {
    if (params.hasOwnProperty(key) && params[key] === undefined) {
      delete params[key];
    }
  }

  return params;
};
